module.exports = __webpack_public_path__ + "static/media/zipeditor.010cbe1c.png";